const initSlider = (identifier, config, breakpoint) => {
    let slider = null;
    if (breakpoint) {
      const runOnMatch = (media) => {
        if (media.matches && !slider) {
          config.init = false;
          slider = new Swiper(identifier, config);
          slider.init();
        }
        if (!media.matches && slider) {
          slider.destroy();
          slider = null;
        }
      };
      const media = window.matchMedia(
        `only screen and (${breakpoint >= 0 ? "min" : "max"}-width: ${
          breakpoint >= 0 ? breakpoint : breakpoint * -1
        }px)`
      );
      runOnMatch(media);
      window.addEventListener("resize", () => {
        runOnMatch(media);
      });
      media.addEventListener("change", runOnMatch);
    } else {
      slider = new Swiper(identifier, config);
    }
  };

document.addEventListener('DOMContentLoaded', () => {
//For Featured brands
    initSlider(".is-brands", {
    loop: true,
    slidesPerView: 'auto', 
    spaceBetween: 0
    });
});

document.addEventListener('DOMContentLoaded', () => {
//For Featured brands
    initSlider(".is-featured", {
    loop: true,
    navigation: {
        prevEl: ".slider-arrow.is-bottom-previous.is-featured",
        nextEl: ".slider-arrow.is-bottom-next.is-featured"
    },
    pagination: {
      el: ".slider_pagination_wrapper.is-featured",
      bulletActiveClass: "is-active",
      bulletClass: "slider_dots",
      clickable: true
    },
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 'auto',
          spaceBetween: 24
        },
        992: {
          slidesPerView: 'auto',
          spaceBetween: 24
        }
    	}
    });

    
});

document.addEventListener('DOMContentLoaded', () => {
//For Testimonial Cards
    initSlider(".is-testimonial", {
    loop: true,
		 autoplay: {
   			delay: 5000,
        pauseOnMouseEnter: true,
        speed: 1600,
		},
    pagination: {
      el: ".slider_pagination_wrapper.is-testimonials",
      bulletActiveClass: "is-active",
      bulletClass: "slider_dots",
      clickable: true
    },
    navigation: {
        prevEl: ".slider-arrow.is-centre-previous.is-testimonial",
        nextEl: ".slider-arrow.is-centre-next.is-testimonial"
    },
		breakpoints: {
        0: {
          slidesPerView: "auto",
            slidesPerGroup: 1, 
          spaceBetween: 24
        },
        768: {
          slidesPerView: 2,
            slidesPerGroup: 1, 
          spaceBetween: 24
        },
        992: {
          slidesPerView: 2,
          slidesPerGroup: 1, 
          spaceBetween: 24
        }
    	}
    }); 
});

document.addEventListener('DOMContentLoaded', () => {
//For Top Products
    initSlider(".is-top-products", {
    loop: true,
    slidesPerView: 'auto',
    spaceBetween: 24,
    navigation: {
        prevEl: ".slider-arrow.is-bottom-previous.is-top-products",
        nextEl: ".slider-arrow.is-bottom-next.is-top-products"
    },
    pagination: {
      el: ".slider_pagination_wrapper.is-top-products",
      bulletActiveClass: "is-active",
      bulletClass: "slider_dots",
      clickable: true
    }
    });
});

document.addEventListener('DOMContentLoaded', () => {
//For Product Categories
    initSlider(".is-product-categories", {
    loop: true,
    slidesPerView: 'auto',
    spaceBetween: 24,
    navigation: {
        prevEl: ".slider-arrow.is-bottom-previous.is-product-categories",
        nextEl: ".slider-arrow.is-bottom-next.is-product-categories"
    },
    pagination: {
      el: ".slider_pagination_wrapper.is-product-categories",
      bulletActiveClass: "is-active",
      bulletClass: "slider_dots",
      clickable: true
    }
    });
});

let mm = gsap.matchMedia();
mm.add("(min-width: 992px)", () => {
gsap.from(".home_brand_grid-item",{
		scrollTrigger: {
    trigger: ".section_home_brand",
    },
		opacity: 0,
		ease: "power1.out",
    y: -200,
    duration: 1,
    stagger: 0.25
  });
});

mm.add("(min-width: 992px)", () => {
	gsap.from(".values_card_item", {
		scrollTrigger: {
    trigger: ".about_values_section"
    },
    x: 200,
    opacity: 0,
    stagger: 2,
    ease: "power3.out",
    duration: 1
	});
  gsap.from(".values_image_background_wrapper", {
		scrollTrigger: {
    trigger: ".about_values_section"
    },
    x: -100,
    opacity: 0,
    stagger: 2,
    ease: "power3.out",
    duration: 1
	});


    	gsap.from(".brand_grid-item",{
      scrollTrigger: {
      trigger: ".brand_grid-item",
      },
      opacity: 0,
      ease: "power1.out",
      x: 100,
      duration: 1,
      stagger: 0.25
    });

    	let headings = gsap.utils.toArray(".interaction_gsap_slide-left");
	headings.forEach(heading => {
  	gsap.from(heading, { 
    	scrollTrigger: {
      trigger: heading,
      start: "top 80%",
    },
     x: 200,
		opacity: 0,
    ease: "power1.out",
    duration: 0.5,
  })
});

});


gsap.from(".swiper-slide.is-featured",{
		scrollTrigger: {
    trigger: ".section_featured-brands",
		start: "top 60%"
    },
		opacity: 0,
		ease: "power1.out",
    x: 200,
    duration: 1,
    stagger: 0.25
  });
gsap.from(".swiper-slide.is-product",{
		scrollTrigger: {
    trigger: ".section_product-category",
		start: "top 60%"
    },
		opacity: 0,
		ease: "power1.out",
    x: 200,
    duration: 1,
    stagger: 0.25
  });
gsap.from(".swiper-slide.is-top-products",{
		scrollTrigger: {
    trigger: ".section_component_top-products",
		start: "top 60%"
    },
		opacity: 0,
		ease: "power1.out",
    x: 200,
    duration: 1,
    stagger: 0.25
  });

document.addEventListener('DOMContentLoaded', () => {
//For Featured brands
    initSlider(".is-home-banner", {
    speed: 500,
  	spaceBetween: 100,
		autoplay: {
		delay: 5000,
 },
	effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
  loop: true
    });
});

// For Gallery
  document.addEventListener('DOMContentLoaded', function() {
    // Initialize Swiper gallery
    const gallerySwiper = new Swiper('.is-gallery', {
      loop: true,
      slidesPerView: 'auto',
      spaceBetween: 12,
      mousewheel: true,
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 12,
        },
        768: {
          slidesPerView: 1,
          spaceBetween: 12,
        },
        992: {
          slidesPerView: 'auto',
          spaceBetween: 12,
        },
      },
      pagination: {
        el: '.slider_pagination_wrapper.is-gallery',
        bulletActiveClass: 'is-active',
        bulletClass: 'slider_dots',
        clickable: true,
      },
    });

    // GSAP Animation for gallery (desktop only)
    if (window.matchMedia('(min-width: 992px)').matches) {
      gsap.from('.gallery_image-item', {
        scrollTrigger: {
          trigger: '.section_gallery',
          start: 'top 70%',
        },
        x: 200,
        autoAlpha: 0,
        stagger: 0.2,
      });
    }
  });



//NAV BAR IMAGE INVERT
  document.addEventListener('DOMContentLoaded', () => {
// Select the navbar element by class or ID (adjust if needed)
const navbar = document.querySelector('.navbar_component');

const targetSelector = '.navbar_logo .header__heading-logo-wrapper img';

// Function to apply or remove the invert filter
function updateImageFilter() {
  const computedColor = getComputedStyle(navbar).color;
  const img = document.querySelector(targetSelector);

  if (img) {
    if (computedColor === 'rgb(12, 12, 12)') {
      img.style.filter = 'invert(1)';
    } else {
      img.style.filter = '';
    }
  }
}

// Create an observer for style attribute changes
const observer = new MutationObserver(updateImageFilter);

observer.observe(navbar, {
  attributes: true,
  attributeFilter: ['style'],
});

// Run once on load
updateImageFilter();

});


   function setupWrapper(wrapper, wrapperIndex) {
    const details = wrapper.querySelectorAll(".product_details");
    const button = wrapper.querySelector(".toggle-details-btn");

    if (!button || button.dataset.toggleInitialized) return;

    // Show first 4
    details.forEach((detail, index) => {
      if (index < 4) {
        detail.style.display = "flex";
        void detail.offsetWidth;
        detail.classList.add("visible");
      } else {
        detail.style.display = "none";
        detail.classList.remove("visible");
      }
    });

    button.addEventListener("click", () => {
      const isExpanded = button.textContent === "See Less";

      details.forEach((detail, index) => {
        if (isExpanded && index >= 4) {
          detail.classList.remove("visible");
          setTimeout(() => {
            detail.style.display = "none";
          }, 300);
        } else if (!isExpanded) {
          detail.style.display = "flex";
          void detail.offsetWidth;
          detail.classList.add("visible");
        }
      });

      button.textContent = isExpanded ? "See More" : "See Less";
    });

    button.dataset.toggleInitialized = "true";
  }

  function initializeAllWrappers() {
    const wrappers = document.querySelectorAll(".product_details-wrapper");
    wrappers.forEach((wrapper, index) => setupWrapper(wrapper, index));
  }

  // Initial setup after delay
  setTimeout(() => {
    initializeAllWrappers();

    // Watch for dynamically added content
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof HTMLElement)) return;

          // If new wrapper is added
          if (node.classList?.contains("product_details-wrapper")) {
            setupWrapper(node, 0);
          }

          // If new product_details are added inside an existing wrapper
          const foundWrappers = node.querySelectorAll?.(".product_details-wrapper") || [];
          foundWrappers.forEach((newWrapper) => setupWrapper(newWrapper, 0));
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }, 1000);




// CMAX SEARCH

// <script>
document.addEventListener("DOMContentLoaded", function () {
  function updateCMAXVisibility() {
    const params = new URLSearchParams(window.location.search);
    const hasFilter = Array.from(params.keys()).some(key => key.startsWith("gf_"));

    document.querySelectorAll(".CMAX").forEach(el => {
      el.style.display = hasFilter ? "none" : "block";
    });
  }

  updateCMAXVisibility();

  // Re-check when URL changes from filter use (AJAX)
  const pushState = history.pushState;
  history.pushState = function () {
    pushState.apply(history, arguments);
    updateCMAXVisibility();
  };

  const replaceState = history.replaceState;
  history.replaceState = function () {
    replaceState.apply(history, arguments);
    updateCMAXVisibility();
  };

  window.addEventListener("popstate", updateCMAXVisibility);

  // Optional fallback in case app doesn't trigger history methods
  setInterval(updateCMAXVisibility, 500);
});


